// src/config/blocks.js
import TestBlockEdit from '../components/Blocks/TestBlock/Edit';
import TestBlockView from '../components/Blocks/TestBlock/View';
import CardListEdit from '../components/Blocks/CardList/Edit';
import CardListView from '../components/Blocks/CardList/View';
import BannerEdit from '../components/Blocks/Banner/Edit';
import BannerView from '../components/Blocks/Banner/View';
import RSSDataEdit from '../components/Blocks/DataFromRSS/Edit';
import RSSDataView from '../components/Blocks/DataFromRSS/View';
import PhotoGalleryEdit from '../components/Blocks/PhotoGallery/Edit';
import PhotoGalleryView from '../components/Blocks/PhotoGallery/View';

import LocalizzazioneEdit from '../components/Blocks/Localizzazione/Edit';
import LocalizzazioneView from '../components/Blocks/Localizzazione/View';

import ListaLuoghiEdit from '../components/Blocks/ListaLuoghi/Edit';
import ListaLuoghiView from '../components/Blocks/ListaLuoghi/View';

import NotiziaEvidenzaEdit from '../components/Blocks/NotiziaInEvidenza/Edit';
import NotiziaEvidenzaView from '../components/Blocks/NotiziaInEvidenza/View';

import asterisk from '@plone/volto/icons/asterisk.svg';
import listaelementi from '@plone/volto/icons/image-left.svg';
import bannerblockicon from '@plone/volto/icons/hero.svg';
import rssIcon from '@plone/volto/icons/rss.svg'; 
import galleryIcon from '@plone/volto/icons/image.svg';
import mapSVG from '@plone/volto/icons/map.svg';

const blocksConfig = {
  bannerBlock: {
    id: 'bannerBlock',
    title: 'Banner custom',
    icon: bannerblockicon,
    group: 'common',
    view: BannerView,
    edit: BannerEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  },
  cardList: { // Uniformato a "cardList" (era "cardlist")
    id: 'cardList',
    title: 'Card List',
    icon: listaelementi,
    group: 'common',
    view: CardListView,
    edit: CardListEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  },
  itemEvidenza: { 
    id: 'itemEvidenza',
    title: 'Item in evidenza',
    icon: bannerblockicon,
    group: 'common',
    view: NotiziaEvidenzaView,
    edit: NotiziaEvidenzaEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  },
  // testBlock: {
  //   id: 'testBlock',
  //   title: 'Blocco di test',
  //   icon: asterisk,
  //   group: 'common',
  //   view: TestBlockView,
  //   edit: TestBlockEdit,
  //   restricted: false,
  //   mostUsed: true,
  //   sidebarTab: 1,
  // },
  rssFeedBlock: {
    id: 'rssFeedBlock',
    title: 'RSS Feed Block',
    icon: rssIcon,
    group: 'common',
    view: RSSDataView,
    edit: RSSDataEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  },
  photoGallery: {
    id: 'photoGallery',
    title: 'Photo Gallery',
    icon: galleryIcon,
    group: 'media',
    view: PhotoGalleryView,
    edit: PhotoGalleryEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  },
  localizzazione: {
    id: 'localizzazione',
    title: 'Localizzazione',
    icon: mapSVG,
    group: 'common',
    view: LocalizzazioneView,
    edit: LocalizzazioneEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  },
  listaluoghi: {
    id: 'listaluoghi',
    title: 'Lista luoghi',
    icon: mapSVG,
    group: 'common',
    view: ListaLuoghiView,
    edit: ListaLuoghiEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  },
};

export default blocksConfig;